<div
    class='agpr-block agpr-chartBlock'
    [ngClass]="{
        'agpr-block--cannot-move': !block.canMove,
        'agpr-chartBlock--preview': preview
    }"
>
    <div
        class="agpr-block-content agpr-chartBlock-content"
    >
        <div
            *ngIf="!renderable"
            class='agpr-block-placeholder'
        >
            <span class="fa agpr-block-placeholderIcon {{ block.type.icon }}" aria-hidden="true"></span>
            <span class="agpr-block-placeholderLabel">{{ block.type.label | localize }}</span>
        </div>
        <!-- chart-->
        <div class="agpr-top-terms-chart-card" *ngIf="series?.length">
            <agpr-top-terms-chart
                [series]="series"
                [header]="displayElement?.title"
                (termSelected)="selectTerm($event)"
                (dataChange)="changeDetectorRef.detectChanges()"
                [tooltipSelectsTerm]="true"
                [initialLabel]="initialLabel"
                [accentColor]="displayElement?.styles?.colorMap?.accentColor"
                [chartOptions]="chartOptions"
                [noContentMessage]="'Common.noContentToDisplay' | localize"
            ></agpr-top-terms-chart>
        </div>
    </div>
    <div
        class="agpr-block-hoverBorder"
    >
    </div>
    <div #exportMenu>
        <div
            *ngIf="actionable && !preview"
            class="agpr-block-icons agpr-block-icons--right"
        >
            <agpr-button
                type="button"
                icon="fa-regular fa-duotone fa-pen"
                class="agpr-block-icon"
                (click)="onAction('edit')"
                tooltip="Reports.chartSetupDialog.editHeading"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
            >
            </agpr-button>
            <agpr-button
                type="button"
                icon="fa-regular fa-arrow-right-from-bracket"
                class="agpr-block-icon"
                [style]="buttonTypes.contextMenu"
            >
            </agpr-button>
            <agpr-chart-export-menu
                class="agpr-chartBlock-exportIcon"
                [supportedFormats]="[ 'png', 'jpg', 'svg', 'csv', 'json', 'print' ]"
                (exportMenuClicked)="chartExport($event)"
            >
            </agpr-chart-export-menu>
            <agpr-button
                type="button"
                icon="fa-regular fa-duotone fa-trash-can"
                class="agpr-block-icon"
                (click)="onAction('delete')"
                tooltip="Reports.chartSetupDialog.deleteChart"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
            >
            </agpr-button>
        </div>
        <div
            *ngIf="actionable && !preview && showMoveButtons"
            class="agpr-block-icons agpr-block-icons--left u-srOnly"
        >
            <button
                pButton
                [disabled]="!block.canMoveUp"
                type="button"
                icon="fa-regular fa-arrow-up"
                class="agpr-block-icon"
                (click)="onMoveUp()"
            >
            </button>
            <button
                pButton
                [disabled]="!block.canMoveDown"
                type="button"
                icon="fa-regular fa-arrow-down"
                class="agpr-block-icon"
                (click)="onMoveDown()"
            >
            </button>
        </div>
    </div>
</div>
<div *ngIf="block.errors?.length > 0" class="agpr-blockError">
    <agpr-form-message
        *ngFor="let error of block.errors"
    >
        {{ error | localize }}
    </agpr-form-message>
</div>
